/*! GhostStat marketing — keeps the hero's network numbers moving.
 *
 * The figures are already rendered server-side, so this script is pure enhancement: if it never
 * runs, the hero still shows real, cached numbers. It refreshes them every 30s from the same public
 * anonymous endpoint published at gs.ghoststat.me, and stays quiet on any failure — a marketing
 * page must never show an error, and must never show an invented number.
 */
(function () {
  "use strict";
  var API = "https://api.ghoststat.me/global/";
  var host = document.querySelector('[data-mk="kpis"]');
  if (!host || !window.fetch) return;

  var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function el(k) { return document.querySelector('[data-mk="' + k + '"]'); }
  function fmt(n) {
    n = +n || 0;
    if (n >= 1e6) return (Math.round(n / 1e5) / 10).toString().replace(/\.0$/, "") + "M";
    if (n >= 1e3) return (Math.round(n / 100) / 10).toString().replace(/\.0$/, "") + "k";
    return String(n);
  }
  function set(k, text) {
    var n = el(k); if (!n || n.textContent === text) return;
    n.textContent = text;
    if (still) return;
    n.classList.add("mk-bump");
    setTimeout(function () { n.classList.remove("mk-bump"); }, 900);
  }
  function get(p) {
    return fetch(API + p, { mode: "cors", credentials: "omit" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return (j && j.data) ? j.data : j; })
      .catch(function () { return null; });
  }

  function tick() {
    if (document.hidden) return;               // don't poll a tab nobody is looking at
    get("map").then(function (d) {
      if (!d || !d.countries || !d.countries.length) return;
      var vi = 0, pv = 0, se = 0, co = 0;
      d.countries.forEach(function (c) {
        var p = +c.pageviews || 0;
        vi += +c.visitors || 0; se += +c.sessions || 0; pv += p; if (p > 0) co++;
      });
      set("k-visitors", fmt(vi)); set("k-pageviews", fmt(pv));
      set("k-sessions", fmt(se)); set("k-countries", String(co));
    });
  }

  setInterval(tick, 30000);
  document.addEventListener("visibilitychange", function () { if (!document.hidden) tick(); });
})();
